import { makeVar } from '@apollo/client'
import { GetDebitCardsListQueryResponse } from 'features/Cards/AllCardsDebit/hooks/useQueryDebitCards/graphql/getDebitCardsList.generated'

type DebitCard = NonNullable<
  GetDebitCardsListQueryResponse['getDebitCardsV2']['cards'][0]
>

export const rvSelectedCard = makeVar<DebitCard | null>(null)
